import React from 'react';

import * as css from './InfoBox.css';

export const InfoBox = ({ children }) => <div className={css.InfoBox}>{children}</div>;
